var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ApplicationIntro',{attrs:{"currentStep":3,"currentStepStartHandler":_vm.nextStep,"blurFutureSteps":"","title":"Looks great! Can’t wait for you to meet our community","subtitle":"Explore properties and future roommates to find the best fit for you. Reach out to homes that you are interested in."}})
}
var staticRenderFns = []

export { render, staticRenderFns }